import { render } from "./StateBadge.vue?vue&type=template&id=ccd9a80e&scoped=true&ts=true&lang=pug"
import script from "./StateBadge.vue?vue&type=script&lang=ts"
export * from "./StateBadge.vue?vue&type=script&lang=ts"

import "./StateBadge.vue?vue&type=style&index=0&id=ccd9a80e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd9a80e"]])

export default __exports__